"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapGqlDataToAccordion = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
const mapGqlDataToAccordion = (graphqlFaqContent)=>{
    if (!graphqlFaqContent || graphqlFaqContent.length < 1) {
        return null;
    }
    return graphqlFaqContent.map((question)=>{
        const { title, content } = question;
        const htmlText = content.map((contentItem)=>{
            var _contentItem_text;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.TextWithHtml, {
                html: (0, _utils.transformHtmlContent)(contentItem)
            }, (_contentItem_text = contentItem.text) !== null && _contentItem_text !== void 0 ? _contentItem_text : title);
        });
        return {
            id: title !== null && title !== void 0 ? title : '',
            title: title !== null && title !== void 0 ? title : '',
            content: htmlText
        };
    });
};
exports.mapGqlDataToAccordion = mapGqlDataToAccordion;
